import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';

function Collection() {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [financeList, setFinanceList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [selectedFinance, setSelectedFinance] = useState(null);
    const [receiptDetails, setReceiptDetails] = useState(null);

    useEffect(() => {
        const fetchFinanceData = async () => {
            try {
                const response = await axiosInstance.get("/finance/open");
                setFinanceList(response.data);
                setFilteredList(response.data);
            } catch (err) {
                console.error("Error fetching finance data:", err);
                setFinanceList([]);
                setFilteredList([]);
            }
        };
        fetchFinanceData();
    }, []);

    useEffect(() => {
        const filtered = financeList.filter((item) =>
            [item.reg_no, item.borrower_name, item.borrower_phone1, item.borrower_phone2]
                .some((field) => field?.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        setFilteredList(filtered);
    }, [searchTerm, financeList]);

    const handleSelectFinance = async (finance) => {
        setSelectedFinance(finance);
        try {
            const res = await axiosInstance.get(`/receipt/previousdetails/${finance.id}`);
            setReceiptDetails(res.data);
            console.log("recipt: ", res.data)
        } catch (err) {
            console.error("Error fetching receipt details:", err);
            setReceiptDetails([]);
        }
    };

    const handleReceipt = async (row) => {

        // Check if vehicle is still seized
        if (row.issizzed == 1 || row.issizzed == true) {
            // Show alert to release vehicle first
            Swal.fire({
                title: 'Cannot Create Receipt!',
                text: 'Please release the vehicle first then create Receipt.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return; // Exit the function
        }

        // Check if vehicle is still seized
        if (row.isclosed == 1 || row.isclosed == true) {
            // Show alert to release vehicle first
            Swal.fire({
                title: 'Cannot Create Receipt!',
                text: 'This Finance is closed already',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return; // Exit the function
        }

        // Show confirmation dialog
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to create receipt?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, create it!',
        });

        if (result.isConfirmed) {
            navigate('/addreceipt', { state: row });
        }
    };


    return (
        <div className="content-wrapper p-4">
            <div className="mb-4">
                <h2 className="mb-3"> Collection Search</h2>
                <input
                    type="text"
                    className="form-control form-control-lg shadow-sm"
                    placeholder="Search by Reg No / Name / Phone"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <div className="card shadow-sm mb-4">
                <div className="card-header bg-dark text-white">
                    <strong>Search Results</strong>
                </div>
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-striped table-hover m-0">
                            <thead className="thead-light">
                                <tr>
                                    <th>Reg No</th>
                                    <th>Borrower Name</th>
                                    <th>Phone 1</th>
                                    <th>Phone 2</th>
                                    <th>EMI Amount</th>
                                    <th>Tenure</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredList.length > 0 ? (
                                    filteredList.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.reg_no}</td>
                                            <td>{item.borrower_name}</td>
                                            <td>{item.borrower_phone1}</td>
                                            <td>{item.borrower_phone2}</td>
                                            <td>₹{item.emi_amount}</td>
                                            <td>{item.tenure_months}</td>
                                            <td>
                                                <button
                                                    className="btn btn-warning btn-sm"
                                                    style={{ marginRight: '8px' }} title="View Finance"
                                                    onClick={() => handleSelectFinance(item)}
                                                >
                                                    <i className="fa fa-eye"></i>
                                                </button>
                                                <button
                                                    className="btn btn-success btn-sm"
                                                    style={{ marginRight: '8px' }} title="Add Receipt"
                                                    onClick={() => handleReceipt(item)}
                                                >
                                                    <i className="fa fa-receipt"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-3">
                                            No matching records found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {selectedFinance && receiptDetails && (
                <div className="card shadow-lg p-4">
                    <h4 className="text-info mb-3">📄 Finance Details</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <p><strong>Borrower Name:</strong> {selectedFinance.borrower_name}</p>
                            <p><strong>Address:</strong> {selectedFinance.borrower_address1}, {selectedFinance.borrower_address2}</p>
                            <p><strong>City:</strong> {selectedFinance.borrower_city}</p>
                            <p><strong>Phone:</strong> {selectedFinance.borrower_phone1}, {selectedFinance.borrower_phone2}</p>
                        </div>
                        <div className="col-md-6">
                            <p>
                                <strong>Finance Date:</strong>{" "}
                                {selectedFinance.date
                                    ? new Date(selectedFinance.date).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                    })
                                    : ""}
                            </p>
                            <p><strong>Loan Amount:</strong> ₹{selectedFinance.loan_amount}</p>
                            <p><strong>EMI:</strong> ₹{selectedFinance.emi_amount} x {selectedFinance.tenure_months}</p>
                            <p><strong>Reg No:</strong> {selectedFinance.reg_no}</p>
                            <p><strong>Vehicle:</strong> {selectedFinance.model} ({selectedFinance.color})</p>
                            <p><strong>Year:</strong> {selectedFinance.make_year}</p>
                        </div>
                    </div>

                    <hr />

                    <h4 className="text-success mb-3">📆 Due Details</h4>
                    <div className="row">
                        <div className="col-md-6">
                            <p><strong>Total Loan Paid:</strong> ₹{receiptDetails.totalpaiddue}</p>
                            <p><strong>Loan Balance:</strong> ₹{receiptDetails.totalbalancedue}</p>
                            <p><strong>Last Due Paid On:</strong>{" "}
                                {receiptDetails.last_paid_date
                                    ? new Date(receiptDetails.last_paid_date).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric"
                                    })
                                    : ""}
                            </p>
                            <p><strong>UnPaid Dues:</strong> {receiptDetails.unpaid_due_count}</p>
                            <p>
                                <strong>UnPaid Due Dates:</strong>{" "}
                                {receiptDetails.unpaid_due_dates
                                    ? receiptDetails.unpaid_due_dates
                                        .map(date =>
                                            new Date(date).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                            })
                                        )
                                        .join(", ")
                                    : ""}
                            </p>
                            <p><strong>Due has to be paid:</strong> ₹ {receiptDetails.due_has_to_paid}</p>
                            <p><strong>Next Due No:</strong> {receiptDetails.due_no}</p>
                            <p><strong>Next Due Date:</strong>{" "}
                                {receiptDetails.due_date
                                    ? new Date(receiptDetails.due_date).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                    })
                                    : ""}
                            </p>

                        </div>
                        <div className="col-md-6">
                            <p><strong>Total Dues:</strong> {receiptDetails.totalduecount}</p>
                            <p><strong>Total Paid Dues:</strong> {receiptDetails.due_receipt_count}</p>
                            <p><strong>Total Pending Dues:</strong> {receiptDetails.balanceduecount}</p>
                            <p><strong>Penalty:</strong> ₹{receiptDetails.penalty}</p>
                            <p><strong>Late Fine:</strong> ₹{receiptDetails.calculated_fine}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Collection;
